import type { ReactNode } from "react";
import { StyleSheet, View, type ViewStyle } from "react-native";

import type { UiTheme } from "../theme";

// <Card> — THE surface box primitive (CN-3 census: ~39 hand-rolled copies of
// "hairline border + r3 + gutter"). One definition of the boxed-surface look so
// a card can't drift in border/radius/padding between screens. Introduced with
// the coach console (CO-8) — the KPI tiles and athlete rows are its first
// callsites; the existing 39 copies migrate boy-scout under CN-3, not here.
//
// Kept a plain surface box on purpose: an at-a-glance alert state is carried by
// the content (a tinted value, a filled Avatar, a status Badge — each with its
// own word/glyph), NOT by tinting the whole card, which would force every text
// token to be re-checked against the fill and land sub-4.5:1 pairings on the
// default light theme (the a11y trap the CO-8 audit caught).

export type CardProps = {
  theme: UiTheme;
  children: ReactNode;
  // Default true → inner padding (s.s4). Pass false when the child manages its
  // own insets (e.g. a full-bleed list).
  padded?: boolean;
  style?: ViewStyle | ViewStyle[];
};

export function Card({ theme, children, padded = true, style }: CardProps) {
  const styles = makeStyles(theme);
  return (
    <View style={[styles.card, padded && styles.padded, style]}>{children}</View>
  );
}

function makeStyles(theme: UiTheme) {
  const { palette: p, spacing: s, radius: r } = theme;
  return StyleSheet.create({
    card: {
      backgroundColor: p.surface,
      borderRadius: r.r3,
      borderWidth: 1,
      borderColor: p.border,
    },
    padded: { padding: s.s4 },
  });
}
